import { render, staticRenderFns } from "./apps-acid-page.vue?vue&type=template&id=bd501206&scoped=true"
import script from "./apps-acid-page.vue?vue&type=script&lang=js"
export * from "./apps-acid-page.vue?vue&type=script&lang=js"
import style0 from "./apps-acid-page.vue?vue&type=style&index=0&id=bd501206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd501206",
  null
  
)

export default component.exports